import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_COLOR, ORDER_ASCENDING } from '../Utils/Constants';
const sRUControllerEndpoint = 'LotCreationL4';


export class UsedRentalsCarsListAPI {
  params;

  constructor() {
    this.params = {};
  }

  getL4List(Id, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_COLOR, order = ORDER_ASCENDING, searchBy = '', colorFilter = 0, optionalsFilter = []) {
    this.params = {
      lRuL1Id: Id,
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      this.params.searchBy = searchBy;
    if (colorFilter)
      this.params.colorFilter = colorFilter;
    if (optionalsFilter)
      this.params.optionalsFilter = optionalsFilter;
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetListLotL4RU', { params: this.params });
  }

  getMinimizedL4List(ruL1Id, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_COLOR, order = ORDER_ASCENDING, colorFilter = 0, optionalsFilter = [], saleChannelFilter = [], reservationFilter = null, stockFilter = null) {
    this.params = {
      ruL1Id,
      page,
      rowsPerPage,
      orderBy,
      order,
      colorFilter,
      optionalsFilter,
      saleChannelFilter,
      reservationFilter,
      stockFilter
    }

    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetMinimizedListL4RU', { params: this.params })
  }

  updateBulkSalesChannelL4(ListCarIds = [], ListSalesChannelIds = [], ForceSave, isToChangeReservations) {
    this.params = {
      ListCarIds,
      ListSalesChannelIds,
      ForceSave,
      isToChangeReservations
    };

    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateBulkSalesChannelLotL4RU', this.params);
  }

  getColorsByRUL1Id(Id) {
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetColorsByRUL1Id?ruL1Id=' + Id);
  }

  getOptionalsByRUL1Id(Id) {
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetOptionalsByRUL1Id?ruL1Id=' + Id);
  }

  deleteCar(Id, ForceSave) {
    this.params = {
      carRuL4ID: Id,
      forceSave: ForceSave
    }
    return axios.delete(getBackendURL() + sRUControllerEndpoint + '/UpdateCarDeleteL4RU', { params: this.params });
  }

  quitDeal(L4Id, forceSave) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateCarQuitDealL4RU?carRuL4ID=' + L4Id + '&forceSave=' + forceSave);
  }

  updateCarInformation(ruL4DTO) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateCarLotL4RU', ruL4DTO);
  }

  updateBulkCarInfo(l1L4DTO) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateBulkLotL4RU', l1L4DTO);
  }

  associateOrderToCar(carDTO) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/UpdateCarOrderLotL4RU', carDTO);
  }

  getRUCarByL4Id(id) {
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetRUCarByL4Id?lRuL4Id=' + id);
  }

  finishFirmPurchasesLot(lotId) {
    return axios.put(getBackendURL() + sRUControllerEndpoint + '/FinishL4Lot?lotId=' + lotId);
  }

}

export default UsedRentalsCarsListAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsCarsListAPI.js